module.exports = __webpack_public_path__ + "static/7-8bd23776e5b00e94134143bbe6d68f28.jpg";